<template>
    <v-form ref="etapeInfoSpplementaires" id="etapeInfoSpplementaires" v-model="$storeCandidature.etapeInfoSpplementairesValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <div id="terminale">
                <v-layout row wrap>
                    <h3>{{$storeCandidature.langueFormulaire == 'en' ? '' : 'Parcours :'}}</h3>
                    <hr size="5" width="100%" color="secondary" class='mb-2'>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SituationActuelleList"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Situation Actuelle'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle && $storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle.Id == fileIdSalarie" row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.StatutVae"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.Statut"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Statut'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle && $storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle.Id != fileIdSalarie" row wrap xs12>
                    <v-textarea outlined
                                v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.SiAutreLaquelle"
                                name="input-7-4"
                                @change="$storeCandidature.candidatureChanged = true"
                                label="Mon message">
                    </v-textarea>
                </v-layout>
                <v-layout v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.Statut && $storeCandidature.sasCandidature.VAECoursDuSoir.Statut.Id == fileIdAutreStatut" row wrap xs12>
                    <v-textarea outlined
                                v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.AutreStatut"
                                name="input-7-4"
                                @change="$storeCandidature.candidatureChanged = true"
                                label="Précisez">
                    </v-textarea>
                </v-layout>
            </div>
        </v-container>
    </v-form>
</template>
<script>
    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                //fileId de la valeur catalogue Situation actuelle = Salarié
                fileIdSalarie: 3935,
                //fileId de la valeur catalogue Situation actuelle = Demandeur d'emplois
                fileIdDemandeurEmplois: 3938,
                //fileId de la valeur catalogue Statut= Autre
                fileIdAutreStatut: 3945,

            }
        },

        methods: {
        },

        mounted() {
            if (this.$refs.etapeInfoSpplementaires) {
                this.$refs.etapeInfoSpplementaires.validate()
            }
        },
    }
</script>

